
export class ElementPath
{
  indexPath:number[];
  element:Element;

  private _indexPath:string;
  get path()
  {
    if ( this._indexPath  )
    {
       return this._indexPath;
    }

    this._indexPath = this.indexPath.join( ":" );

    return this._indexPath;
  }
}

export class ElementHierarchy
{
  pathMap:Map<string,ElementPath> = new Map<string,ElementPath>();
  paths:ElementPath[] = [];

  get( element:Element )
  {
    this.getPaths( element, null, 0 );
  }

  getPaths( element:Element, parentPath:ElementPath, index:number )
  {
    let elementPath = new ElementPath();
    let hasParent = parentPath != null;
    elementPath.element = element;

    let elementIndexPath = [ index ];
    let parentIndexPath = hasParent ? parentPath.indexPath : [];    
    elementPath.indexPath = parentIndexPath.concat( elementIndexPath );
    
    this.paths.push( elementPath );

    this.pathMap.set( elementPath.path, elementPath );

    let elementIndex = 0;

    for ( let i = 0; i < element.childNodes.length; i++ )
    {
      let child = element.childNodes[ i ];

      if ( Node.ELEMENT_NODE != child.nodeType )
      {
        continue;
      }

      this.getPaths( child as Element, elementPath, elementIndex );
      elementIndex ++;
    }
  }
}
